import despia from 'despia-native';

// Check if we're in a Despia native context
const isDespia = typeof navigator !== 'undefined' && navigator.userAgent.includes('despia');

export async function hapticLight() {
  try {
    if (isDespia) {
      despia('lighthaptic://');
    } else if (navigator.vibrate) {
      navigator.vibrate(10);
    }
  } catch {
    // Silently fail if haptics unavailable
  }
}

export async function hapticMedium() {
  try {
    if (isDespia) {
      despia('heavyhaptic://');
    } else if (navigator.vibrate) {
      navigator.vibrate(25);
    }
  } catch {
    // Silently fail if haptics unavailable
  }
}

export async function hapticHeavy() {
  try {
    if (isDespia) {
      despia('heavyhaptic://');
    } else if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  } catch {
    // Silently fail if haptics unavailable
  }
}

// New Despia-specific haptic types
export async function hapticSuccess() {
  try {
    if (isDespia) {
      despia('successhaptic://');
    } else if (navigator.vibrate) {
      navigator.vibrate([10, 50, 10]);
    }
  } catch {
    // Silently fail if haptics unavailable
  }
}

export async function hapticWarning() {
  try {
    if (isDespia) {
      despia('warninghaptic://');
    } else if (navigator.vibrate) {
      navigator.vibrate([30, 30, 30]);
    }
  } catch {
    // Silently fail if haptics unavailable
  }
}

export async function hapticError() {
  try {
    if (isDespia) {
      despia('errorhaptic://');
    } else if (navigator.vibrate) {
      navigator.vibrate([50, 50, 50, 50]);
    }
  } catch {
    // Silently fail if haptics unavailable
  }
}
